export const getIsFetching = state => state.editUser.isFetching;
export const getMessage = state => state.editUser.errorMessage;
export const getSessionRol = state => state.editUser.errorRol;
